const Menu = [
  {
    path: "/",
    icon: "fa fa-th",
    title: "Inicio",
  },
  {
    path: "/actividades",
    icon: "fa fa-star",
    title: "Actividades",
    children: [
      { path: "/actividades/registro", title: "Registro" },
      { path: "/actividades/lista", title: "Lista" },
    ],
  },
  {
    path: "/ordenes",
    icon: "fas fa-money-check",
    title: "Órdenes de pago",
  },
  {
    path: "/solicitudes/drycip",
    icon: "fa fa-address-card",
    title: "Solicitudes",
  },
  {
    path: "/impresion_licencias",
    icon: "fa fa-print",
    title: "Impresión",
  },
  {
    path: "/sustancias",
    icon: "fas fa-vial",
    title: "Sustancias",
  },
  {
    path: "/sanciones",
    icon: "fa fa-exclamation-circle",
    title: "Sanciones",
  },
  {
    path: "/recetas-electronicas/expedidas",
    icon: "fa fa-file-prescription",
    title: "Recetas Electrónicas",
  },
  {
    path: "/asociar-medico-comercializador",
    icon: "fa fa-user-md",
    title: "Asociar médico a establecimiento",
  },
  {
    path: "/movimiento-productos",
    icon: "fa fa-truck",
    title: "Movimiento productos",
    children: [
      { path: "/movimientos-productos/historial", title: "Historial" },
      { path: "/movimientos-productos/inventario", title: "Inventario" },
    ],
  },
  {
    path: "/Metas",
    icon: "fa fa-flag-checkered",
    title: "Metas",
  },
  {
    path: "/notificacionesBoletin",
    icon: "fa fa-bell",
    title: "Notificaciones",
  },
  {
    path: "/Clasificacion-productos",
    icon: "fas fa-list",
    title: "Clasificación de productos",
  },
  {
    path: "/reportes-importacion-general",
    icon: "fas fa-vial",
    title: "Reportes importación medicamentos",
  },
  {
    path: "/sustancia-reporte-medicamento-controlado",
    icon: "fas fa-file-excel",
    title: "Reportes medicamentos controlados",
  },
  {
    path: "/establecimientos",
    icon: "fa fa-building",
    title: "Establecimientos",
  },
  {
    path: "/Visitas-fiscalizacion",
    icon: "fas fa-clipboard-check",
    title: "Visitas fiscalización",
  },
];

export default Menu;
